import { OrganisationService } from './../../../tabs/services/organisation.service';
import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../services/api.service';
import {ProfileModel} from '../../../../models/profile/profile.model';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AddPhoneService {

  constructor(
      private api: ApiService,
      private http: HttpClient,
      private organisationService: OrganisationService,
  ) { }

 public postAddPhone(profile: ProfileModel, phone): Observable<any> {
    return this.organisationService.getCurrentOrganisation().pipe(
      switchMap(organisationId => this.api.getHeaders().pipe(
        switchMap(headers => this.http.post(
          this.api.getHostVersion() + '/organisation/' + organisationId + '/profile/' + profile.id + '/recognition-phone',
          phone,
          { headers }
        ))
      ))
    );
  }
}
